import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "form", "content", "success", "submitButton"]

  connect() {
    // Check if already shown this session
    if (localStorage.getItem('poolflow_exit_shown')) {
      return
    }

    // Check if user has already signed up (don't show to returning users)
    if (document.cookie.includes('_poolflow_session')) {
      // Could check for logged in state, but this is a simple approach
    }

    // Add mouseleave listener for desktop
    this.boundHandleMouseLeave = this.handleMouseLeave.bind(this)
    document.addEventListener('mouseleave', this.boundHandleMouseLeave)
  }

  disconnect() {
    if (this.boundHandleMouseLeave) {
      document.removeEventListener('mouseleave', this.boundHandleMouseLeave)
    }
  }

  handleMouseLeave(event) {
    // Only trigger when mouse leaves from the top of the viewport
    if (event.clientY <= 0) {
      this.showModal()
      // Remove listener after showing once
      document.removeEventListener('mouseleave', this.boundHandleMouseLeave)
    }
  }

  showModal() {
    // Don't show if already shown
    if (localStorage.getItem('poolflow_exit_shown')) {
      return
    }

    this.modalTarget.classList.remove('hidden')
    document.body.style.overflow = 'hidden'

    // Track FB event
    if (typeof fbq !== 'undefined') {
      fbq('trackCustom', 'ExitIntentShown')
    }
  }

  closeModal() {
    this.modalTarget.classList.add('hidden')
    document.body.style.overflow = ''

    // Mark as shown so it doesn't appear again this session
    localStorage.setItem('poolflow_exit_shown', 'true')
  }

  async submitLead(event) {
    event.preventDefault()

    const form = this.formTarget
    const submitButton = this.submitButtonTarget
    const formData = new FormData(form)

    // Disable button
    submitButton.disabled = true
    submitButton.textContent = 'Submitting...'

    try {
      const response = await fetch('/go/lead', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({
          name: formData.get('name'),
          email: formData.get('email'),
          phone: formData.get('phone'),
          source: 'facebook'
        })
      })

      const data = await response.json()

      if (data.success) {
        // Track FB event
        if (typeof fbq !== 'undefined') {
          fbq('track', 'Lead')
        }

        // Show success message
        this.contentTarget.classList.add('hidden')
        this.successTarget.classList.remove('hidden')

        // Mark as shown
        localStorage.setItem('poolflow_exit_shown', 'true')
      } else {
        const errorMsg = data.errors?.join(', ') || 'Something went wrong. Please try again.'
        if (window.showToast) {
          window.showToast(errorMsg, 'error')
        } else {
          alert(errorMsg)
        }
        submitButton.disabled = false
        submitButton.textContent = 'Keep Me Posted'
      }
    } catch (error) {
      const errorMsg = 'Something went wrong. Please try again.'
      if (window.showToast) {
        window.showToast(errorMsg, 'error')
      } else {
        alert(errorMsg)
      }
      submitButton.disabled = false
      submitButton.textContent = 'Keep Me Posted'
    }
  }

  trackCTA() {
    // Track FB event when CTA is clicked
    if (typeof fbq !== 'undefined') {
      fbq('track', 'InitiateCheckout')
    }

    // Mark exit intent as "shown" so it doesn't appear if they come back
    localStorage.setItem('poolflow_exit_shown', 'true')
  }
}
